import { DatePicker2 } from '@alifd/next';
import wrapper from './next-wrapper';
const FormDatePicker = wrapper(DatePicker2, 'CbayelFormDatePicker');
export default FormDatePicker;
